/*
 * Public API Surface of material
 */

export * from './lib/material.module';
